export enum VoteState {
    UNKNOWN = '',
    COMPLETE = 'complete',
    FAILED = 'failed',
}